import { searchByKeys } from '@witmetrics/utils/arrays';
import {
  FILE_COLLECTION_TYPE_ID,
  KEYPOINT_TYPE_ID,
} from '@witmetrics/utils/constants';
import type {
  DecoratedUnisonProject,
  DecoratedUnisonProjectFileCollection,
} from '@witmetrics/utils';
import { currentDate } from '@witmetrics/utils/time';
import { API } from '@/api';

const { DOCUMENTS } = FILE_COLLECTION_TYPE_ID;

export const classes = {
  wrapper: 'size-full px-2 py-8',
  header: 'place-start w-full px-2 pb-4',
  title: 'mr-2',
  breadcrumbs: 'pt-0 pb-4',
  tab: 'p-4 h-full',
  card: 'py-4 px-0 h-full',
  emptyWrapper: 'size-full place-center flex-col pt-12',
  emptyTitle: 'text-grey-7 dark:text-mauve-2 text-xl',
  emptyMessage: 'text-grey-7 dark:text-mauve-2 text-base pt-4',
  filesWrapper: 'flex flex-wrap gap-6 w-full pt-4 px-2',
  skeleton: 'h-32 w-44 rounded-lg',
};

export const styles = {
  skeleton: (delay: number) => ({
    '&:after': {
      animationDelay: `${delay}s`,
      animationDuration: '1.2s',
    },
  }),
};

export function filterCollectionItems<
  T extends { name: string; description?: string | null },
>(items: T[] | null, searchQuery: string) {
  return searchByKeys(items || [], ['name', 'description'], searchQuery);
}

export async function createFileKeypoint(
  project: DecoratedUnisonProject,
  fileId: number
) {
  const keypoint = await API.Keypoints.createNewKeypoint({
    practiceId: project.practiceId,
    keypointTypeId: KEYPOINT_TYPE_ID.FILES_UPLOADED,
    startsAt: currentDate(),
    content: { unisonProjectId: project.id, fileId },
  });
  return API.UnisonProjects.addKeypointToUnisonProject(project.id, keypoint.id);
}

export async function createDocumentsCollection(
  project: DecoratedUnisonProject
): Promise<DecoratedUnisonProjectFileCollection> {
  const fileCollection = await API.FileCollections.createNewFileCollection({
    name: `${project.name} (documents)`,
    practiceId: project.practiceId,
    fileCollectionTypeId: DOCUMENTS,
  });
  const projectCollection =
    await API.UnisonProjects.addFileCollectionToUnisonProject(
      project.id,
      fileCollection.id
    );
  return { ...projectCollection, fileCollection };
}
